import { useMemo } from 'react'
import { useSpaceIdFromPathname } from 'hooks/useSpaceInfoFromPathname'
import {
    useConnectivity,
    useLinkedAndDelegatedWallets,
    useMembershipStatus,
    useMyUserId,
} from 'use-towns-client'

export function useMyMembershipStatus({ spaceId: spaceIdIn }: { spaceId?: string } = {}) {
    const spaceIdFromPathname = useSpaceIdFromPathname()
    const spaceId = spaceIdIn ?? spaceIdFromPathname
    const { loggedInWalletAddress } = useConnectivity()
    // We probably do not need to pass wallets with delegations here, being extra cautious.
    const { data: wallets } = useLinkedAndDelegatedWallets({ walletAddress: loggedInWalletAddress })
    const myUserId = useMyUserId()
    const args = useMemo(
        () => ({
            spaceNetworkId: spaceId ?? '',
            userId: myUserId ?? '',
            wallets: wallets ?? [],
        }),
        [spaceId, myUserId, wallets],
    )
    return useMembershipStatus(args)
}
